// The first-time tutorial (client/tutorial.ts): a dimmed screen that points at
// one thing at a time. Only trainers made after it shipped get one; everyone
// else can replay it from Help.
//
// 'hunt': brand new. The hunt waits until the trainer picks their first wild,
//   so the first fight is one they chose and can watch.
// 'tour': hunting; the walk-through of the screen is still to finish.
// Absent: done or skipped (and every older account).
export type TutorialStage = 'hunt' | 'tour';

/** True while a new trainer's hunt waits for their first pick. */
export function tutorialHolds(t: { tutorial?: TutorialStage }): boolean {
  return t.tutorial === 'hunt';
}
